<template>
  <div class="mt-sm-4">
    <h4 class="mb-2 text-info">
      <span v-if="data.exchange_id">{{ data.exchange_id }}</span>
    </h4>
    <ul class="mb-4">
      <template v-for="(r, key) in requests">
        <li v-if="r.body" :key="key" class="mb-3">
          <!-- <span class="badge badge-info mr-2">{{ r.state }}</span> -->
          <span v-if="r.state === 'done'">
            <div>
              <span class="text-success"
                >{{ "get_file_epolis" | setText("Получить файл e-polis") }}:
              </span>
              <a class="btn btn-info" :href="r.file">{{
                "donwload_file" | setText("Скачать файл")
              }}</a>
            </div>
          </span>
          <span v-if="r.state === 'confirm'">
            <div>
              <span class="text-success"> e-polis: </span>
              <span>
                {{ r.response.polis_sery }}-{{ r.response.polis_number }}
              </span>
              <a
                v-if="r.response.polis_check"
                :href="r.response.polis_check"
                target="_blank"
                class="btn btn-danger"
              >
               
                {{ "see" | setText("Посмотреть") }}
              </a>
            </div>
          </span>
          <span v-if="r.state === 'sent'">
            <div>
              <span class="text-info"
                >{{ "cotract_number" | setText("Номер контракта") }}:
              </span>
              <span>{{ r.response.contract_id }}</span>
            </div>
            <div>
              <span class="text-info"
                >{{ "insurance_premium" | setText("Страховое награждение") }}:
              </span>
              <span
                >{{
                  r.response.insurance_premium | spaceBetweenNumber
                }}
                UZS</span
              >
            </div>
            <div>
              <span class="text-info"
                >{{ "insurance_premium" | setText("Страховая сумма") }}:
              </span>
              <span
                >{{
                  Math.round(r.response.insurance_liability, 2)
                    | spaceBetweenNumber
                }}
                UZS</span
              >
            </div>
          </span>
        </li>
      </template>
    </ul>
    <component
      :is="state"
      :currentRequest="currentRequest"
      :data="data"
      v-model="setValue"
      :id="data.id"
      @update="update"
      :type="type"
    />
  </div>
</template>
<script>
import { spaceBetweenNumber } from "../../../plugins/filtersTemplate";

export default {
  methods: {},
  components: {
    new: () => import("./new"),
    sent: () => import("./sent"),
    cancel: () => import("./cancel"),
    done: () => import("./done"),
    confirm: () => import("./confirm"),
  },
  methods: {
    update() {
      this.$emit("update", true);
    },
  },
  data: () => ({}),
  props: ["value", "data", "type"],
  computed: {
    requests() {
      return this.data.service_requests.filter(
        (item) => item && item.service && item.service.code === "semurg"
      );
    },
    currentRequest() {
      try {
        return this.requests[0];
      } catch (error) {}

      return null;
    },
    state() {
      return this.currentRequest && this.currentRequest["state"]
        ? this.currentRequest["state"]
        : "cancel";
    },
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
 